import {
  getLastUpdateTime,
  findList,
  getDetail,
  addToCart,
  getCartCount,
  getCartList,
  removeCart,
  submitCart,
  applyForBasfProductTabAuth
} from '@/axios/api/basfProductClient'
import { url } from '../../axios/api_urls/ingredientSelection'
import $axios from '@/axios/config.js'
const state = {
  listData: [],
  pager: {
    current: 1,
    size: 12
  },
  total: 0,
  detail: {
    mainInfo: {}
  },
  cartNum: 0,
  cartList: []
}

const getters = {
  listData: state => state.listData,
  pager: state => state.pager,
  total: state => state.total,
  cartNum: state => state.cartNum,
  cartList: state => state.cartList,
  detail: state => {
    return {
      ...state.detail,
      competitorProductsText: (state.detail.competitorProducts || []).map(v => v.tradeName).join(', ')
    }
  }
}

const UPDATE_LIST_DATA = 'UPDATE_LIST_DATA'
const UPDATE_PAGER = 'UPDATE_PAGER'
const UPDATE_TOTAL = 'UPDATE_TOTAL'
const UPDATE_DETAIL = 'UPDATE_DETAIL'
const UPDATE_CART_NUM = 'UPDATE_CART_NUM'
const UPDATE_CART_LIST = 'UPDATE_CART_LIST'

const mutations = {
  [UPDATE_LIST_DATA] (state, listData) {
    state.listData = listData
  },
  [UPDATE_PAGER] (state, pager) {
    state.pager = pager
  },
  [UPDATE_TOTAL] (state, total) {
    state.total = total
  },
  [UPDATE_DETAIL] (state, detail) {
    state.detail = detail
  },
  [UPDATE_CART_NUM] (state, cartNum) {
    state.cartNum = cartNum
  },
  [UPDATE_CART_LIST] (state, cartList) {
    state.cartList = cartList
  }
}

const actions = {
  // 请求页面头部信息
  async getLastUpdateTimeApi ({ state, commit }, params) {
    try {
      let { data: res } = await getLastUpdateTime({...params})
      return res
    } catch (e) {
      return {}
    }
  },
  // 获取列表
  async findListApi ({ state, commit }, params) {
    try {
      let { data: res } = await findList({...params})
      commit(UPDATE_LIST_DATA, res.list || [])
      commit(UPDATE_TOTAL, res.total || 0)
    } catch (e) {
    }
  },
  // 设置page
  setPagerApi ({commit}, pager) {
    commit(UPDATE_PAGER, pager)
  },
  // 获取详情
  async getDetailApi ({ state, commit }, params) {
    try {
      let { data: res } = await getDetail(params)
      commit(UPDATE_DETAIL, res || {})
    } catch (e) {
    }
  },
  download (content, payload) {
    return $axios({
      url: url.download,
      method: 'get',
      params: { ...payload },
      responseType: 'arraybuffer'
    })
  },
  // 获取详情
  async addToCartApi ({ state, commit }, params) {
    try {
      let res = await addToCart(params)
      return res
    } catch (e) {
      return false
    }
  },
  // 获取购物车数量
  async getCartCountApi ({ state, commit }) {
    try {
      let { data: res } = await getCartCount()
      commit(UPDATE_CART_NUM, res || 0)
    } catch (e) {
      return false
    }
  },
  // 获取购物车数量
  async getCartListApi ({ state, commit }) {
    try {
      let { data: res } = await getCartList()
      commit(UPDATE_CART_LIST, res || [])
    } catch (e) {
      return false
    }
  },
  // 购物车删除
  async removeCartApi ({ state, commit }, params) {
    try {
      let { data: res } = await removeCart(params)
      return res
    } catch (e) {
      return false
    }
  },
  // 提交购物车
  async submitCartApi ({ state, commit }, params) {
    try {
      let res = await submitCart(params)
      return res && res.errorCode === 200
    } catch (e) {
      return false
    }
  },
  // 详情页申请权限
  async applyForBasfProductTabAuthApi ({ state, commit }, params) {
    try {
      let res = await applyForBasfProductTabAuth(params)
      return res
    } catch (e) {
      return false
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/basfProductClient.js